export const readEmpty = async (skip,user) => {
    try{
        console.log("read empty")
        const res = await fetch( 
            `${process.env.REACT_APP_BACKEND_URL}/listKontrakTempEmpty?skip=${skip}&user=${user}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            }
        );
        return await res.json();
    } catch(error){
        throw new Error(error);
    }
}